import React, {useLayoutEffect, useRef} from "react";

// Native inert blocks keyboard, contenteditable, drag/drop and custom controls,
// while the enclosing Grid card remains selectable for inspection.
export function PreviewBoundary({readOnly = false, children}: {readOnly?: boolean; children: React.ReactNode}) {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {ref.current.inert = readOnly;}, [readOnly]);
  return <div ref={ref} data-grid-readonly={readOnly || undefined}>{children}</div>;
}
